import { cloneDeep } from 'lodash';

import { BENEFIT_ENQUIRIES, CO_APPLICANT_BENEFIT, CO_APPLICANT_REASON, LOCATION_TYPE } from '@funnels/constants';
import { BrokerInterviews } from '@funnels/types';

export const BROKER_INTERVIEW_MOCK_DATA: BrokerInterviews[] = [
  {
    id: 'brokerInterview-1',
    clientId: 'brokerInterview-1-client',
    applicationId: 'application-1',
    loanTermSoughtDescription: 'string',
    refinancingAndDebtConsolidationMeetsObjectives: true,
    productSelection: 'string',
    allApplicantsUnderstandEnglish: true,
    locationType: LOCATION_TYPE.LendiApprovedPhoneInterview,
    location: '8 Fake Street, Miranda, NSW, Australia',
    allApplicantsPresent: true,
    attendees: ['applicant-1'],
    allApplicantsBenefit: true,
    substantialBenefit: [
      {
        applicantId: 'applicant-1',
        coApplicantBenefit: CO_APPLICANT_BENEFIT.SubstantialBenefit,
        benefitEnquiries: [BENEFIT_ENQUIRIES.ProportionsInAssetsPurchased],
        benefitEnquiriesDescription: 'string',
        coApplicantReason: [CO_APPLICANT_REASON.SpousalAssetProtectionTaxBenefitsOrDebtReduction],
        suspectExperiencingFinancialAbuse: true,
        understandsCoApplicantObligations: true,
      },
    ],
  },
];

export const getMockBrokerInterviews = (): BrokerInterviews[] => cloneDeep(BROKER_INTERVIEW_MOCK_DATA);
